import { getTranslation } from '@easy-expense/intl-client';
import React from 'react';

import { Survey } from '../../components/OnboardingFlow/Survey/Survey';

interface WorkExpenseSurveyProps {
  selectedOptions: string[];
  onSelect: (options: string[]) => void;
  type: 'home' | 'meals' | 'drive';
}

export const WorkExpenseSurvey: React.FC<WorkExpenseSurveyProps> = ({
  selectedOptions,
  onSelect,
  type,
}) => {
  const getQuestionConfig = () => {
    switch (type) {
      case 'home':
        return {
          header: getTranslation('Do you ever work from home?'),
          text: getTranslation('Track your home office expenses for tax deductions'),
          options: [
            {
              title: getTranslation('Yes'),
              success: getTranslation('You may be eligible for home office deductions'),
            },
            {
              title: getTranslation('No'),
              success: getTranslation('No problem, we will focus on other deductions'),
            },
          ],
        };
      case 'meals':
        return {
          header: getTranslation(
            'Do you ever go out to eat and talk about work with clients or colleagues?',
          ),
          text: getTranslation('Track your business meal expenses for tax deductions'),
          options: [
            {
              title: getTranslation('Yes'),
              success: getTranslation('Business meals are 50-100% tax deductible'),
            },
            {
              title: getTranslation('No'),
              success: getTranslation('No problem, we will focus on other deductions'),
            },
          ],
        };
      case 'drive':
        return {
          header: getTranslation('Do you ever drive for work?'),
          text: getTranslation('Track your mileage for tax deductions'),
          options: [
            {
              title: getTranslation('Yes'),
              success: getTranslation('Track mileage automatically with Easy Expense'),
            },
            {
              title: getTranslation('No'),
              success: getTranslation('No problem, we will focus on other deductions'),
            },
          ],
        };
      default:
        return {
          header: '',
          text: '',
          options: [],
        };
    }
  };

  const config = getQuestionConfig();

  return (
    <Survey
      header={config.header}
      text={config.text}
      options={config.options}
      multiSelect={false}
      onOptionSelected={onSelect}
      selectedOptions={selectedOptions}
    />
  );
};
